// extracted by mini-css-extract-plugin
export default {"helped":"Helped_helped__LGuIq","number_helped":"Helped_number_helped__ak6Zr","text_helped":"Helped_text_helped__G+D5Q","block_helped":"Helped_block_helped__Qn77D"};